import request from "./request";

const client = {
  /**
   * Factory function for http get
   * @async
   * @function getRequest
   * @param {string} url - The url to which the get request is made
   * @param options
   * @return Promise object
   */
  async getRequest(url, options = {}) {
    return request({
      method: "get",
      url,
      ...options,
    });
  },
  async deleteRequest(url, data, options = {}) {
    return request({
      method: "delete",
      url,
      data,
      ...options,
    });
  },
  /**
   * Factory function for http post
   * @async
   * @function postRequest
   * @param {string} url - The url to which the get request is made
   * @param {string} data - The data object send
   * @param options
   * @return Promise object
   */
  async postRequest(url, data, options = {}) {
    return request({
      method: "post",
      url,
      data,
      ...options,
    });
  },
  /**
   * Factory function for http put
   * @async
   * @function putRequest
   * @param {string} url - The url to which the get request is made
   * @param {string} data - The data object send
   * @param options
   * @return Promise object
   */
  async putRequest(url, data, options = {}) {
    return request({
      method: "put",
      url,
      data,
      ...options,
    });
  },
};

export default client;
